module.exports = __webpack_public_path__ + "df13bc809bf080c2dd5fe0ddab02aa80.png";